import { render, staticRenderFns } from "./TableCareProject.vue?vue&type=template&id=23ebeecf&scoped=true"
import script from "./TableCareProject.vue?vue&type=script&lang=js"
export * from "./TableCareProject.vue?vue&type=script&lang=js"
import style0 from "./TableCareProject.vue?vue&type=style&index=0&id=23ebeecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebeecf",
  null
  
)

export default component.exports